export default defineNuxtPlugin(() => {
    console.log('[Object]: Init.');
    return {
        provide: {
            objectMap: (obj: any, fn: Function) => Object.fromEntries(
                Object.entries(obj).map(([k, v], i) => [k, fn(v, k, i)])
            ),
            getChanges: (original: any, updated: any) => {
                const diff: Partial<any> = {};

                for (const key in updated) {
                    if ((updated as any)[key] !== (original as any)[key]) {
                        (diff as any)[key] = (updated as any)[key]
                    }
                }

                return diff;
            }
        }
    }
});